import type { CalculatorInputField } from 'components/Calculator/config/types';

/**
 * Input keys an editor has used more than once.
 *
 * Duplicate keys collapse silently: the fields share one value, so typing in
 * one moves the other and a formula can only ever read the last. Result keys
 * already report their own collisions, so leaving input keys to fail quietly
 * would be the odd one out.
 *
 * @param inputs - The input fields as configured in Builder
 * @returns Each repeated key once, in the order it first repeats
 */
export const findDuplicateInputKeys = (inputs: CalculatorInputField[]): string[] => {
  const seen = new Set<string>();

  return inputs.reduce<string[]>((duplicates, { key }) => {
    if (!seen.has(key)) {
      seen.add(key);

      return duplicates;
    }

    return duplicates.includes(key) ? duplicates : [...duplicates, key];
  }, []);
};
